import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { UserApiService } from '../../../services/user-api.service';
import { Auth } from '@synegen/utility';
import { UserResponse } from '../../../types/user.types';

export const userResolver: ResolveFn<UserResponse | null> = (route) => {
  let id = route.paramMap.get('id');
  console.log(id);
  if ('my-profile' === route.routeConfig?.path) {
    id = <string>inject(Auth).user()?.['id'];
  }
  if ('create' === route.routeConfig?.path) {
    return of(null);
  }

  return inject(UserApiService).getUser(Number(id));
};
